import { cn } from "@/lib/utils";
import type { OrderStatus } from "@cold-crew/shared";

const STATUS_CONFIG: Record<OrderStatus, { label: string; className: string }> = {
  pendiente: { label: "Pendiente", className: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400" },
  pagado:    { label: "Pagado",    className: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400"         },
  entregado: { label: "Entregado", className: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400" },
  cancelado: { label: "Cancelado", className: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400"              },
};

export function OrderStatusBadge({ status, className }: { status: OrderStatus; className?: string }) {
  const cfg = STATUS_CONFIG[status];
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium", cfg.className, className)}>
      {cfg.label}
    </span>
  );
}
